import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/useI18n";
import { Sparkles, Check, ShieldCheck, ArrowRight } from "lucide-react";

// Fires once per session when a desktop visitor moves the cursor to leave the tab.
export default function ExitIntentOffer() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { if (sessionStorage.getItem("ags_exit_shown")) return; } catch (e) {}
    let armed = false;
    const arm = setTimeout(() => { armed = true; }, 4000); // don't fire on immediate mouse jitter
    const onOut = (e) => {
      if (!armed) return;
      if (!e.relatedTarget && e.clientY <= 0) {
        armed = false;
        try { sessionStorage.setItem("ags_exit_shown", "1"); } catch (err) {}
        setOpen(true);
      }
    };
    document.addEventListener("mouseout", onOut);
    return () => { clearTimeout(arm); document.removeEventListener("mouseout", onOut); };
  }, []);

  const bullets = t("exit.bullets", [
    "A month of concrete, anti-slop posts",
    "Copy & post in one tap — no accounts to connect",
    "Cancel anytime — no lock-in",
  ]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md border-border bg-card p-0 overflow-hidden" data-testid="exit-intent-offer">
        <DialogTitle className="sr-only">Special Pro offer</DialogTitle>
        <div className="bg-gradient-to-br from-primary/20 via-transparent to-accent/10 p-6 sm:p-8">
          <div className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1 rounded-full bg-accent/15 text-accent border border-accent/30 mb-4">
            <Sparkles className="h-3.5 w-3.5" /> {t("exit.badge", "Wait — before you go")}
          </div>
          <h2 className="text-2xl font-display font-bold tracking-tight">
            {t("exit.title_pre", "Get a full month of posts with")} <span className="text-primary">Pro</span>
          </h2>
          <p className="text-sm text-muted-foreground mt-2">
            {t("exit.desc", "Generate an entire month of on-brand posts in one click. Plans from $29/mo — with Shopify automation on E-commerce Growth. Cancel anytime.")}
          </p>
          <ul className="mt-5 space-y-2 text-sm">
            {(Array.isArray(bullets) ? bullets : []).map((b) => (
              <li key={b} className="flex items-start gap-2"><Check className="h-4 w-4 text-emerald-400 mt-0.5 shrink-0" /> <span>{b}</span></li>
            ))}
          </ul>
          <Link to="/start" onClick={() => setOpen(false)} data-testid="exit-intent-cta">
            <Button size="lg" className="w-full mt-6 bg-primary hover:bg-primary/90 text-white group">
              {t("exit.cta", "Get started")} <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
          <button onClick={() => setOpen(false)} data-testid="exit-intent-dismiss"
            className="w-full mt-3 text-xs text-muted-foreground hover:text-foreground transition-colors">
            {t("exit.dismiss", "No thanks, I'll keep posting manually")}
          </button>
          <p className="flex items-center justify-center gap-1.5 text-[11px] text-muted-foreground mt-4">
            <ShieldCheck className="h-3.5 w-3.5 text-emerald-400" /> {t("exit.footer", "Plans from $29/mo · cancel anytime")}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
